<div class="dates-dropdown">
  <div class="dates-dropdown__header">
    <button type="button" class="dates-dropdown__nav dates-dropdown__nav--prev" (click)="prevMonth.emit()">‹</button>
    <div class="dates-dropdown__months-titles">
      @for (month of months; track month.title) {
        <div class="dates-dropdown__month-title">{{ month.title }}</div>
      }
    </div>
    <button type="button" class="dates-dropdown__nav dates-dropdown__nav--next" (click)="nextMonth.emit()">›</button>
  </div>

  <div class="dates-dropdown__months">
    @for (month of months; track month.title) {
      <div class="dates-dropdown__month">
        <div class="dates-dropdown__weekdays">
          @for (weekDay of weekDays; track weekDay) {
            <span class="dates-dropdown__weekday">{{ weekDay }}</span>
          }
        </div>
        <div class="dates-dropdown__grid">
          @for (cell of month.cells; track $index) {
            @if (cell.key) {
              <button type="button"
                      class="dates-dropdown__day"
                      [class.available]="isDateAvailable(cell.key)"
                      [class.selected]="isDateSelected(cell.key)"
                      [class.in-range]="isDateInRange(cell.key)"
                      [class.range-start]="isRangeStart(cell.key)"
                      [class.range-end]="isRangeEnd(cell.key)"
                      [class.disabled]="!canSelectDate(cell.key)"
                      [disabled]="!canSelectDate(cell.key)"
                      (click)="dateSelected.emit(cell.key)">
                {{ cell.day }}
              </button>
            } @else {
              <span class="dates-dropdown__day dates-dropdown__day--empty"></span>
            }
          }
        </div>
      </div>
    }
  </div>

  @if (showFlexibleDates) {
    <div class="dates-dropdown__footer">
      <label class="dates-dropdown__flexible-toggle">
        <input type="checkbox" [checked]="isFlexibleDates" (change)="onFlexibleDatesChange($event)">
        <span>± 2 дня</span>
      </label>
    </div>
  }
</div>
